import { AuthCallbackType, Role, SigninCredentialsPayload, SignupCredentialsPayload } from '@ui/interfaces'
import axios from '@ui/lib/api/axiosHelper'

export const authService = {
  isAuthenticated: false,

  async signupWithPassword(credentials: SignupCredentialsPayload, callback: AuthCallbackType) {
    const configuration = {
      url: '/v1/users',
      data: credentials,
      headers: {
        'Content-Type': 'application/json',
      },
    }

    await axios
      .post(configuration.url, configuration.data)
      .then((response) => {
        authService.isAuthenticated = true
        callback(null, response.data)
      })
      .catch((error) => {
        callback(error)
      })
  },

  async signinWithPassword(credentials: SigninCredentialsPayload, callback: AuthCallbackType) {
    const configuration = {
      url: '/v1/users/sign_in',
      data: credentials,
      headers: {
        'Content-Type': 'application/json',
      },
    }

    await axios
      .post(configuration.url, configuration.data)
      .then((response) => {
        authService.isAuthenticated = true
        callback(null, response.data)
      })
      .catch((error) => {
        const { response } = error

        callback(response)
      })
  },

  async signout(callback: AuthCallbackType) {
    const configuration = {
      url: '/v1/users/sign_out',
    }

    await axios
      .delete(configuration.url)
      .then((response) => {
        authService.isAuthenticated = false
        callback(null, response.data)
      })
      .catch((err) => {
        console.log('Failed to signout: ', err)
        callback(err)
      })
  },

  async resetPassword(email: string, callback: AuthCallbackType) {
    const configuration = {
      url: '/v1/users/password',
      data: { user: { email } },
      headers: {
        'Content-Type': 'application/json',
      },
    }

    await axios
      .post(configuration.url, configuration.data)
      .then((response) => {
        authService.isAuthenticated = false
        callback(null, response.data)
      })
      .catch((err) => {
        console.log('Failed to signout: ', err)
        callback(err)
      })
  },

  async setPassword(
    password: string,
    passwordConfirmation: string,
    resetPasswordToken: string,
    callback: AuthCallbackType
  ) {
    const configuration = {
      url: '/v1/users/password',
      data: {
        user: {
          password,
          password_confirmation: passwordConfirmation,
          reset_password_token: resetPasswordToken,
        },
      },
      headers: {
        'Content-Type': 'application/json',
      },
    }

    await axios
      .put(configuration.url, configuration.data)
      .then((response) => {
        authService.isAuthenticated = true
        callback(null, response.data)
      })
      .catch((err) => {
        console.log('Failed to set password: ', err)
        callback(err)
      })
  },

  async invited(password: string, passwordConfirmation: string, token: string, callback: AuthCallbackType) {
    const configuration = {
      url: '/v1/users/invitation',
      data: {
        user: {
          password,
          password_confirmation: passwordConfirmation,
          invitation_token: token,
        },
      },
      headers: {
        'Content-Type': 'application/json',
      },
    }

    await axios
      .put(configuration.url, configuration.data)
      .then((response) => {
        authService.isAuthenticated = true
        callback(null, response.data)
      })
      .catch((err) => {
        console.log('Failed to set password: ', err)
        callback(err)
      })
  },

  async confirmEmail(token: string, isDemo: boolean, callback: AuthCallbackType) {
    const configuration = {
      url: `/v1/users/confirmation?confirmation_token=${token}&is_demo=${isDemo}`,
      headers: {
        'Content-Type': 'application/json',
      },
    }

    await axios
      .get(configuration.url)
      .then((response) => {
        authService.isAuthenticated = true
        callback(null, response.data)
      })
      .catch((err) => {
        console.log('Failed to confirm email: ', err)
        callback(err)
      })
  },

  setOrganization: async (id: number, callback: AuthCallbackType) => {
    const configuration = {
      url: '/v1/users/set_organization',
      data: { id },
      headers: {
        'Content-Type': 'application/json',
      },
    }

    await axios
      .post(configuration.url, configuration.data)
      .then((response) => {
        callback(null, response.data)
      })
      .catch((err) => {
        console.log('Failed to set organization: ', err)
        callback(err)
      })
  },

  validateSession: async () => {
    try {
      const response = await axios.get('/v1/users/validate_session')
      return response.data
    } catch (err) {
      console.log(err)
      return null
    }
  },

  updateRole: async (userId: number, organizationId: number, role: Role) => {
    try {
      const response = await axios.put(`/v1/organizations/${organizationId}/members/${userId}`, { user: { role } })
      return response.data
    } catch (err) {
      console.log(err)
      return null
    }
  },
}
